import { cn } from '../../lib/cn';
import type { ConnectorRow } from '../../unifiedcommerce/framework';

type Props = { connectors?: ConnectorRow[] };

export function MarketplaceConnectorsPanel({ connectors = [] }: Props) {
  return (
    <div className="space-y-2">
      {connectors.map((c) => (
        <div key={c.connector} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{c.connector}</p>
            <p className="mt-0.5 text-xs text-slate-500">last sync {c.lastSync}</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              c.status === 'connected' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
            )}>
              {c.status}
            </span>
            {c.health > 0 && <p className="mt-1 text-xs text-slate-500">{c.health}% health</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
